import React from "react";
import InteractiveMap from "./InteractiveMap";
import SearchBar from "../components/SearchBar";
import StaticText from "../components/StaticText";
import greenTicketsLogoName from "../resources/images/green-tickets-logo-name.png";
import sailScannerLogo from "../resources/images/sailscanner-logo.png";
import {Button, Header, Loader, Menu, Modal} from "semantic-ui-react";
import {connect} from "react-redux";
import * as InteractiveMapActions from "../actions/InteractiveMapActions";
import {NavLink} from "react-router-dom";
import {Segment} from "semantic-ui-react/dist/commonjs/elements/Segment";
import RightTopText from "../components/RightTopText";

class HomePage extends React.Component {

    state = {
        modalOpen: false,
        modalTextLabel: "",
        modalHeader: "",
        active: "home",
    };

    open = (modalTextLabel, modalHeader) => this.setState({
        modalOpen: true,
        active: modalTextLabel,
        modalTextLabel,
        modalHeader,
    });
    handleClose = () => this.setState({
        modalOpen: false,
        active: "home",
    });

    static scrollTo(id) {
        document.getElementById(id).scrollIntoView();
    }

    render() {

        // const {userActivityHasStarted} = this.props;
        //" + (userActivityHasStarted ? " folded" : "")"

        return <div className="full-map">

            <div className="map-container">

                <InteractiveMap/>

                <div className="intro-text">
                    {/*<h1>SailScanner</h1><br/>*/}
                    <img src={sailScannerLogo} alt="SailScanner" />
                </div>

                <div className="top-left-menu">

                    <div className="top padding">

                        <Menu inverted secondary>
                            <Menu.Item name="Home" active={this.state.active === "home"} onClick={() => this.handleClose()} />
                            <Menu.Item name="FAQ" active={this.state.active === "faq"} onClick={() => this.open("faq", "FAQ")}  />
                            <Menu.Item name="About" active={this.state.active === "contact"} onClick={() => this.open("contact", "About SailScanner")} />
                        </Menu>

                        <RightTopText />

                        <SearchBar />

                    </div>

                    {/*<Button as={NavLink} size="small" to="/faq">FAQ</Button>*/}
                    {/*<Button size="small" onClick={() => this.open("contact", "About SailScanner")}>About</Button>*/}
                </div>

                <div className="search-bar-container">
                    {/*<SearchBar/>*/}
                </div>

                <div className="absolute-footer">
                    <a href="https://www.greentickets.app" target="_blank">Powered by <img src={greenTicketsLogoName}
                                                                                           alt="Green Tickets - Building the European travel planner of the future."/></a>
                </div>

                {/*<div className="cookie-bar">*/}
                    {/*<div className="padding">*/}
                        {/*By using this site you agree to cookies! {" "}*/}
                        {/*<Button size="mini">Accept</Button>*/}
                    {/*</div>*/}
                {/*</div>*/}

            </div>

            <div
                 style={{display: this.state.modalOpen ? "block" : "none"}}
                // onClose={this.props.onClose}
                 className="route-info-modal-container"
                // open={this.state.modalOpen}
                // centered={false}
                // closeIcon={true}
                onClose={this.handleClose}>
                <Header>{this.state.modalHeader}</Header>
                <div>
                    <StaticText label={this.state.modalTextLabel}/>
                </div>
            </div>
        </div>
    }
}


export default connect(state => ({
    // userActivityHasStarted: state.interactiveMap.userActivityHasStarted,
}), dispatch => ({}))(HomePage)


// WEBPACK FOOTER //
// ./src/homepage/Homepage.js